import { CarouselType } from '@ui-system/interfaces-carousel';
import { pleaseImplement } from '@ui-system/utils';

const Carousel = pleaseImplement<CarouselType>('Carousel');

export default Carousel;
